// extracted by mini-css-extract-plugin
export default {"skillScroll":"ScrollComponent_skillScroll__65Qwc","track":"ScrollComponent_track__st+Z5","scrollLeft":"ScrollComponent_scrollLeft__gSXP1","skill":"ScrollComponent_skill__X26f1"};